import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withRouteAccessCheck } from '../../../../app/Hoc/WithLoginAceessCheck';

const Onts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card card-custom  bg-transparent sales-card  border-0 px-0">
            <div className="card-header min-h-1px bg-transparent border-0 px-0 ">
              <div className="card-title flex-fill">
                <form action="" className="col-12 px-0">
                  <div className="row align-items-end">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">Service Address</label>
                        <input type="text" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">ONT Serial No.</label>
                        <input type="text" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">Subscriber ID</label>
                        <input type="text" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <buttom className="btn btn-custom electric_cobalt min-h-55px">
                          Search
                        </buttom>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="card card-custom card-xxl-stretch">
                <div className="card-header d-flex justify-content-between align-items-stretch with_hr_tabs">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                      >
                        Provisioned ONT
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                      >
                        Unassigned ONT
                      </button>
                    </li>
                  </ul>
                  <div className="head_btn align-items-center d-flex">
                    <button className="btn btn-custom export">
                      Export{' '}
                      <span>
                        <img src="/images/export.svg" alt="" />
                      </span>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="home-tab-pane"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                      tabIndex="0"
                    ></div>
                    <div
                      className="tab-pane fade"
                      id="profile-tab-pane"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                      tabIndex="0"
                    >
                      ...
                    </div>
                    <div
                      className="tab-pane fade"
                      id="contact-tab-pane"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                      tabIndex="0"
                    >
                      ...
                    </div>
                    <div
                      className="tab-pane fade"
                      id="disabled-tab-pane"
                      role="tabpanel"
                      aria-labelledby="disabled-tab"
                      tabIndex="0"
                    >
                      ...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouteAccessCheck(Onts);
